import { render } from "./payment_term_option.vue?vue&type=template&id=aad23dfa"
import script from "./payment_term_option.vue?vue&type=script&lang=js"
export * from "./payment_term_option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__